import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'
import {Button} from '../../../partials/widgets'
import {KTSVG} from '../../../helpers'
import AuthService from '../../../../app/modules/auth/core/_requests'
import useCancelToken from '../../../hooks/UseCancelToken'
import {toast} from 'react-toastify'

const TopAlert = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(false)
  const {newCancelToken, isCancel} = useCancelToken()

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const body = document.body
      if (body.classList.contains('modal-open')) {
        body.style.paddingRight = '0px'
      }
    })

    observer.observe(document.body, {attributes: true, attributeFilter: ['class']})

    return () => observer.disconnect()
  }, [])

  const resendVerificationEmail = async () => {
    try {
      setLoading(true)
      const config = {cancelToken: newCancelToken()}
      let payload = {
        identifier: currentUser?.email || '',
      }
      const response = await AuthService.resendVerificationEmail(payload, config)
      if (response) {
        toast.success(intl.formatMessage({id: 'ENTER_VERIFICATION_ACCOUNT_SENT'}))
      }
    } catch (error: any) {
      if (isCancel(error)) return
      toast.error(intl.formatMessage({id: 'SEND_VERIFICATION_ACCOUNT_ERROR'}))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div id='top-alert' className='top-alert'>
      <div className='container-xxl'>
        <div className='d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 py-3 text-center text-md-start'>
          <div className='d-flex flex-column align-items-center align-items-md-start text-center text-md-start gap-2 gap-md-4'>
            <span className='email-not-verified fs-5 fw-semibold'>
              {intl.formatMessage({id: 'EMAIL_NOT_VERIFIED'}, {email: currentUser?.email})}
            </span>
          </div>
          <Button
            className='btn btn-warning px-4 py-3 rounded-1 fs-6 fw-medium text-black d-inline-flex align-items-center flex-row-reverse gap-2 w-100 w-md-auto justify-content-center mt-1 mt-md-0'
            label={intl.formatMessage({id: 'RESEND_VERIFICATION_LINK'})}
            loadingText={intl.formatMessage({id: 'RESEND_VERIFICATION_LINK'})}
            loading={loading}
            disabled={loading}
            event={resendVerificationEmail}
          >
            <KTSVG path='/media/gori/arrows/arrow_right.svg' className='svg-icon-2 text-black' />
          </Button>
        </div>
      </div>
    </div>
  )
}

export {TopAlert}
